import React, { useEffect } from 'react';
import {
  Dialog,
  IconButton,
  Typography,
  DialogBody,
  DialogHeader,
  DialogFooter,
} from '@material-tailwind/react';

import { XMarkIcon } from '@heroicons/react/24/outline';
import { useForm } from 'react-hook-form';
import InputGlobal from '../InputGlobal';
import ButtonGlobal from '../ButtonGlobal';
import bgRadiantBlue from '../bgRadiantBlue';
import MsgSucess from '../MsgSucess';
import { usePath } from '../../hook/linhaCategorias';
import { useErroControlManul } from '../../hook/useErroControlManul';

export function AddModalCatLn({
  modal,
  handleModal,
  id = null,
  url,
  title,
  news,
  NewCategoria = false,
}) {
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();
  const { result, pathsCall, resetResult } = usePath(url);
  const { useArrayErrorForm } = useErroControlManul();

  const onSubmit = (data) => {
    const valor = data.nome;
    pathsCall({
      nome: valor.toLowerCase(),
      categoriaProduto: id,
    });
  };

  useEffect(() => {
    return () => clearErrors();
  }, []);

  useEffect(() => {
    if (result.sucess) {
      news();
    }
  }, [result]);

  useEffect(() => {
    if (result.error) {
      if (result.error?.non_field_errors) {
        setError('nome', {
          type: 'manual',
          message: 'Categoria ja cadastrada',
        });
      } else {
        useArrayErrorForm(result.error, setError);
      }
    }
  }, [result]);

  const resetInfo = () => {
    reset();
    resetResult();
    handleModal();
  };

  return (
    <>
      <Dialog
        size="sm"
        open={modal}
        handler={resetInfo}
        className={`p-4 bg-lightMenu dark:bg-none dark:bg-darkColorBg`}
      >
        <DialogHeader className="relative m-0 block">
          <Typography variant="h4" className="text-black dark:text-darkText">
            {title}
          </Typography>
          <IconButton
            size="sm"
            variant="text"
            className="!absolute right-3.5 top-3.5"
            onClick={resetInfo}
          >
            <XMarkIcon className="h-4 w-4 stroke-2 dark:text-darkText" />
          </IconButton>
        </DialogHeader>
        <DialogBody className="space-y-4 pb-6">
          <form className="flex flex-col gap-5" onSubmit={handleSubmit(onSubmit)}>
            <div>
              <InputGlobal
                formCamp="nome"
                type="text"
                label="Nome "
                placeholder="Nome"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.nome ? errors : false}
                css="w-full"
                error={result.error}
              />
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <ButtonGlobal
            className="ml-auto"
            click={handleSubmit(onSubmit)}
            color="blue"
            text={'Cadastrar'}
          />
        </DialogFooter>
        {result?.sucess && <MsgSucess reset={resetInfo} />}
      </Dialog>
    </>
  );
}
